import { isValidAlphaNumericButNotNumeric } from '@utils/characters';
import { TypeOfPropsFor } from '@utils/types';

import { FormattedInputBuilder } from './common';

const blocks = {
  FIRST_BLOCK: {
    mask: '0000',
  },
  SECOND_BLOCK: {
    mask: '0000',
  },
  THIRD_BLOCK: {
    mask: '00',
  },
};

export const HopiNumber = FormattedInputBuilder({
  mask: 'FIRST_BLOCK SECOND_BLOCK THIRD_BLOCK',
  blocks,
  name: 'hopiNumber',
  shouldPreventChar: isValidAlphaNumericButNotNumeric,
});
export default HopiNumber;

export type PhonNumberProps = TypeOfPropsFor<typeof HopiNumber>;
